import React from 'react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { Button } from '../../ui/button';
import { GuestLinksProps } from '../types';
import { cn } from '@/lib/utils';

export const GuestLinks: React.FC<GuestLinksProps> = ({ links, className }) => {
  const t = useTranslations('Header');

  const defaultLinks = [
    {
      label: t('signIn'),
      href: '/login',
      variant: 'secondary' as const,
    },
  ];

  const linksToRender = links || defaultLinks;

  return (
    <div className={cn('flex items-center space-x-4', className)}>
      {linksToRender.map((link, index) => (
        <Link key={index} href={link.href}>
          <Button
            variant={link.variant || 'secondary'}
            size='sm'
            className={cn(
              'transition-colors',
              link.variant === 'secondary' && 'bg-white text-gray-900 hover:bg-gray-100',
              link.variant === 'ghost' && 'text-white hover:text-gray-200',
            )}
          >
            {link.label}
          </Button>
        </Link>
      ))}
    </div>
  );
};
